const colors = {
  primary: '#12355b',
  secondary: '#D72638',
  tertiary: '#0B2027',
  background: '#fff',
  text: '#262626'
}

export default colors
